import { render, staticRenderFns } from "./nbn-technical-details.vue?vue&type=template&id=cdec7baa"
import script from "./nbn-technical-details.vue?vue&type=script&lang=js"
export * from "./nbn-technical-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports